// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"1e529b85","605":"ec46ace6","753":"17c21a8d","981":"af54fb05"}[chunkId] + ".chunk.js";
};